/* /pages/fit-guide da copia da Pepper. O scope remove os <script> do tema dele; aqui volta
   o comportamento do global.js/buttons-to-sections.js dele, sobre o markup ja renderizado
   que o extract copiou (os custom elements viraram div.ce-* (kmark)):
   - botoes do topo: rolagem suave ate a ancora, descontando o header fixo
   - cl-before-after: arrastar a linha revela a outra foto (beforeEffectslider dele)
   - cl-sizing-calculator: IN/CM, "Get my size" -> tamanho ou erro; "Shop Bras" leva o
     tamanho para o filtro da colecao (?70618611795=30A, o mesmo parametro do dele)
   - cl-size-chart-expander: seta abre/fecha a tabela; IN/CM troca a tabela             */
(function () {
  'use strict';

  /* ---------------- ancoras ---------------- */
  function anchors(root) {
    root.querySelectorAll('.buttons__container a[href^="#"]').forEach(function (a) {
      a.addEventListener('click', function (e) {
        var t = document.getElementById(a.getAttribute('href').slice(1)); if (!t) return;
        e.preventDefault();
        var hdr = document.querySelector('#header-component, .header-section, header');
        var off = hdr ? hdr.getBoundingClientRect().height : 0;
        var bar = a.closest('.buttons__container'); if (bar) off += bar.getBoundingClientRect().height;
        var pw = document.querySelector('.page-wrapper'); var y = t.getBoundingClientRect().top - off;
        if (pw && pw.scrollHeight > pw.clientHeight + 5 && getComputedStyle(pw).overflowY !== 'visible') pw.scrollBy({ top: y, behavior: 'smooth' }); else window.scrollTo({ top: y + window.pageYOffset, behavior: 'smooth' });
        history.replaceState(history.state, '', '#' + t.id);
      });
    });
  }

  /* ---------------- antes/depois ---------------- */
  function beforeAfter(el) {
    var main = el.querySelector('.before-effect-main-div'); if (!main || main.__cl) return; main.__cl = true;
    var res = main.querySelector('.before-effect-resizable-div'), line = main.querySelector('.before-effect-line');
    var imgs = main.querySelectorAll('img');
    function fit() { var w = main.getBoundingClientRect().width; imgs.forEach(function (i) { i.style.width = w + 'px'; }); }
    function set(pct) {
      pct = Math.max(5, Math.min(95, pct));
      res.style.width = pct + '%'; line.style.left = pct + '%';
    }
    function at(x) { var r = main.getBoundingClientRect(); set((x - r.left) / r.width * 100); }
    var drag = false;
    main.style.touchAction = 'pan-y';
    main.addEventListener('pointerdown', function (e) { drag = true; main.style.cursor = 'grabbing'; at(e.clientX); try { main.setPointerCapture(e.pointerId); } catch (x) { } });
    main.addEventListener('pointermove', function (e) { if (drag) at(e.clientX); });
    ['pointerup', 'pointercancel'].forEach(function (t) { main.addEventListener(t, function () { drag = false; main.style.cursor = ''; }); });
    window.addEventListener('resize', fit); fit();
  }

  /* ---------------- calculadora ---------------- */
  var RIB = { inch: { 30: [25, 26.9], 32: [27, 28.9], 34: [29, 30.9], 36: [31, 32.9], 38: [33, 34.9], 40: [35, 36.9] },
              cm: { 30: [63, 67.9], 32: [68, 72.9], 34: [73, 77.9], 36: [78, 82.9], 38: [83, 87.9], 40: [88, 92.9] } };
  var CUP = { inch: { 30: { 32: 'AA', 30: 'A' }, 32: { 34: 'AA', 32: 'A', 30: 'B' }, 34: { 36: 'AA', 34: 'A', 32: 'B' }, 36: { 38: 'AA', 36: 'A', 34: 'B' }, 38: { 40: 'AA', 38: 'A', 36: 'B' }, 40: { 40: 'A', 38: 'B' }, 42: { 40: 'B' } },
              cm: { 80: { 32: 'AA', 30: 'A' }, 84: { 34: 'AA', 32: 'A', 30: 'B' }, 88: { 36: 'AA', 34: 'A', 32: 'B' }, 92: { 38: 'AA', 36: 'A', 34: 'B' }, 96: { 40: 'AA', 38: 'A', 36: 'B' }, 100: { 40: 'A', 38: 'B' }, 104: { 40: 'B' } } };
  var BUST = { inch: [[30, 31.75, 30], [31.76, 33.24, 32], [33.25, 34.24, 34], [34.25, 35.74, 36], [35.75, 37.74, 38], [37.75, 39.99, 40], [40, 41, 42]],
               cm: [[76, 80.5, 80], [80.51, 84.49, 84], [84.5, 86.99, 88], [87, 89.99, 92], [90, 95.99, 96], [96, 101.49, 100], [101.5, 104, 104]] };
  function round(v) { v = parseFloat(String(v).trim().replace(',', '.')); var f = v % 1, i = v - f; return f > 0.5 ? i + 1 : i; }
  function calculator(el) {
    if (el.__cl) return; el.__cl = true;
    var q = function (s) { return el.querySelector(s); };
    var variant = el.getAttribute('data-variant') || 'inch';
    var tog = q('.toggle-switch-checkbox');
    var parts = [q('.toggle-btn.toggle-inch'), q('.toggle-btn.toggle-cm'), q('.calculator-input-fields-wrapper.inch-variant'), q('.calculator-input-fields-wrapper.cm-variant')];
    function flip() {
      variant = variant === 'inch' ? 'cm' : 'inch'; el.setAttribute('data-variant', variant);
      if (tog) tog.checked = variant === 'cm';
      parts.forEach(function (p) { if (p) p.classList.toggle('active', p.classList.contains(variant === 'inch' ? 'toggle-inch' : 'toggle-cm') || p.classList.contains(variant + '-variant')); });
    }
    el.querySelectorAll('.toggle-btn, .toggle-switch-label').forEach(function (b) { b.addEventListener('click', function (e) { e.preventDefault(); flip(); }); });
    var res = q('.calculator-results'), out = q('.pepper-size-results-wrapper'), title = q('.result-title'), err = q('.error-wrapper'), shop = q('.pepper-results-shop-btn');
    function band(v) { v = round(v); var t = RIB[variant]; for (var k in t) if (v >= t[k][0] && v <= t[k][1]) return k; return false; }
    function bust(v) { v = +String(v).trim().replace(',', '.'); var t = BUST[variant]; for (var i = 0; i < t.length; i++) if (v >= t[i][0] && v <= t[i][1]) return t[i][2]; return ''; }
    function go(e) {
      if (e) e.preventDefault();
      var box = q('.' + variant + '-variant');
      var b = band(box.querySelector('.ribcage-input').value), u = bust(box.querySelector('.bust-input').value);
      var cup = b && u && CUP[variant][u] ? CUP[variant][u][b] : false;
      if (!(b && u && cup)) {
        err.classList.remove('stealth'); res.classList.add('stealth'); shop.classList.add('stealth'); return;
      }
      err.classList.add('stealth'); res.classList.remove('stealth', 'mobile-hidden'); shop.classList.remove('stealth');
      res.classList.add('border-black'); if (title) title.classList.add('color-black');
      var size = b + '' + cup; if (size.indexOf('XL') > -1) size = cup;
      out.textContent = size; out.classList.remove('stealth');
      var a = q('.shop_my_size'); a.setAttribute('href', (a.getAttribute('data-href') || '/collections/bras') + '?70618611795=' + size);
    }
    q('.calculator-get-results').addEventListener('click', go);
    el.querySelectorAll('input[type=number]').forEach(function (i) { i.addEventListener('keyup', function (e) { if (e.key === 'Enter') go(e); }); });
  }

  /* ---------------- tabelas de medidas ---------------- */
  function chart(el) {
    if (el.__cl) return; el.__cl = true;
    var op = el.querySelector('.menu-opener-wrapper');
    function toggle() { el.setAttribute('aria-expanded', el.getAttribute('aria-expanded') === 'true' ? 'false' : 'true'); }
    if (op) { op.setAttribute('role', 'button'); op.setAttribute('tabindex', '0'); op.setAttribute('aria-label', 'Expand size chart');
      op.addEventListener('click', toggle);
      op.addEventListener('keydown', function (e) { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); toggle(); } }); }
    var ttl = el.querySelector('.size_chart_title'); if (ttl) { ttl.style.cursor = 'pointer'; ttl.addEventListener('click', toggle); }
    var inch = el.querySelector('[data-type="inch"]'), cm = el.querySelector('[data-type="cm"]');
    var tog = el.querySelector('.toggle-switch-checkbox');
    function unit(u) {
      if (inch) inch.style.display = u === 'inch' ? '' : 'none';
      if (cm) cm.style.display = u === 'cm' ? '' : 'none';
      el.querySelectorAll('.size_chart_selector_btn').forEach(function (b) { b.classList.toggle('active', b.classList.contains(u)); });
      el.querySelectorAll('.toggle-btn').forEach(function (b) { b.classList.toggle('active', b.classList.contains('toggle-' + u)); });
      if (tog) tog.checked = u === 'cm';
    }
    el.querySelectorAll('.size_chart_selector_btn').forEach(function (b) { b.addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); unit(b.classList.contains('cm') ? 'cm' : 'inch'); }); });
    el.querySelectorAll('.toggle-btn, .toggle-switch-label').forEach(function (b) {
      b.addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); unit(cm && cm.style.display === 'none' ? 'cm' : 'inch'); });
    });
  }

  function init() {
    anchors(document);
    document.querySelectorAll('.ce-before-after').forEach(beforeAfter);
    document.querySelectorAll('.ce-sizing-calculator').forEach(calculator);
    document.querySelectorAll('.ce-size-chart-expander').forEach(chart);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
